<template>
  <div class="input-hidden">
    <input
      :id="id"
      v-model="value"
      :name="id"
      :required="required"
      :aria-required="required" />
  </div>
</template>

<script setup>
  import { useField } from 'vee-validate'

  const props = defineProps({
    name: String,
    id: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    initialValue: [
      String,
      Number,
      Boolean
    ],
    modelValue: String
  })

  defineEmits([ 'update:modelValue' ])

  const { value } = useField(() => props.name, undefined, {
    validateOnValueUpdate: false,
    syncVModel: true,
    ...(props.initialValue ? { initialValue: props.initialValue } : {})
  })
</script>

<style lang="scss" scoped>
  .input-hidden {
    display: none;
  }
</style>
